// Re-export domain types for company
import { api as registrationApi } from '@repo/api-kit/registration';

export type ApiCompany = registrationApi.company.firstparty.v1.ApiCompany;
export type ApiAddress = registrationApi.company.firstparty.v1.ApiAddress;
export type ApiAddressType = registrationApi.company.firstparty.v1.ApiAddressType;
export type ApiFinancialDetail = registrationApi.company.firstparty.v1.ApiFinancialDetail;
export type ApiTaxResidence = registrationApi.company.firstparty.v1.ApiTaxResidence;

export const ApiAddressType = registrationApi.company.firstparty.v1.ApiAddressType;
